import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ProblemSearch } from '../components/ProblemSearch';

export const DashboardPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const resetKey = searchParams.get('reset') || 'default';

  return <ProblemSearch key={resetKey} />;
};